import axios from "axios";
import { API_URL } from "../config/constant";
import CryptoJS from "crypto-js";

export function initiateIncredApplication(
  formData,
  navigate,
  handleFormSubmit,
  setIsDisableBtn,
  setDisplay
) {
  axios
    .post(API_URL + "incred/initiate-application", formData)
    .then((res) => {
      const { data } = res;
      if (data?.status === true) {
        const encryptedAppId = CryptoJS.AES.encrypt(
          data?.response?.APPLICATION_ID,
          "finlab-encryption-key"
        ).toString();
        const encryptedCustId = CryptoJS.AES.encrypt(
          data?.response?.CUSTOMER_ID,
          "finlab-encryption-key"
        ).toString();
        navigate(
          `/congratulations?_ref=${encodeURIComponent(
            encryptedAppId
          )}&_cust=${encodeURIComponent(encryptedCustId)}`
        );
      } else {
        handleFormSubmit();
      }
      setIsDisableBtn(false);
      setDisplay("none");
    })
    .catch((e) => {
      console.log(e);
      setIsDisableBtn(false);
      setDisplay("none");
    });
}
